<template>
  <v-toolbar
    app
    color="blue-grey darken-1"
  >
  <div class="clutteringNavbar d-inline-flex">

      <router-link class="brand" to="/">
         <img v-if="this.language == 'EN'" style="height: 35px" class="mt-0 hidden-md-and-up" src="@/assets/logo_1.svg" >
         <img v-if="this.language == 'EN'" style="height: 35px" class="mt-0 hidden-sm-and-down" src="@/assets/logo_1.svg">
         <img v-if="this.language == 'PT'" style="height: 35px" class="mt-0 hidden-md-and-up" src="@/assets/logo_1.svg" >
         <img v-if="this.language == 'PT'" style="height: 35px" class="mt-0 hidden-sm-and-down" src="@/assets/logo_1.svg">
         <!--
       -->
      </router-link>
      <v-spacer></v-spacer>
      <div class="hidden-md-and-up" style="text-align: right;">
        <v-toolbar-side-icon dark @click.stop="drawerState"></v-toolbar-side-icon>
      </div>
      <div class="hidden-sm-and-down pt-1" style="text-align: right;">
        <v-btn v-if="this.language == 'EN'" flat small @click="gotoscroll('top')" color="white">Home</v-btn>
        <v-btn v-if="this.language == 'PT'" flat small @click="gotoscroll('top')" color="white">Inicial</v-btn>
<v-btn v-if="this.language == 'EN'" flat  small @click="gotoscroll('solucoes')"  color="white">Solutions</v-btn>
        <v-btn v-if="this.language == 'PT'" flat  small @click="gotoscroll('solucoes')"  color="white">Soluções</v-btn>
        <v-btn v-if="this.language == 'EN'" flat small @click="gotoscroll('quem_somos')"  color="white">Who</v-btn>
        <v-btn v-if="this.language == 'PT'" flat small @click="gotoscroll('quem_somos')"  color="white">Quem somos</v-btn>
        <v-btn v-if="this.language == 'EN'" flat small @click="gotoscroll('parceiros')"  color="white">Partners</v-btn>
        <v-btn v-if="this.language == 'PT'" flat small @click="gotoscroll('parceiros')"  color="white">Parceiros</v-btn>
        <v-btn v-if="this.language == 'EN'" flat small @click="gotoscroll('contato')"  color="white">Contact</v-btn>
        <v-btn v-if="this.language == 'PT'" flat small @click="gotoscroll('contato')"  color="white">Contato</v-btn>
        <v-btn v-if="this.language == 'EN'" round outline small @click="entrarLoginWindow()"  color="amber accent-3">Log In</v-btn>
        <v-btn v-if="this.language == 'PT'" round outline small @click="entrarLoginWindow()"  color="amber accent-3">Entrar</v-btn>
        <v-btn v-if="this.language == 'EN'" round outline small @click="changeLanguage('PT')"  color="amber accent-3">Português</v-btn>
        <v-btn v-if="this.language == 'PT'" round outline small @click="changeLanguage('EN')"  color="amber accent-3">English</v-btn>
      </div>

  </div>
  </v-toolbar>
</template>

<style lang="scss" scoped>
  .brand {
    display: flex;
    align-items: center;
  }
</style>

<script>
import { mapGetters, mapState } from 'vuex'
import { NAV_DRAWER, LANGUAGE, ENTRAR_WINDOW, ENTRARLOGIN } from '../../store/actions/navigation'
import { CLOSE_BUTTON_ALL } from '../../store/actions/navigation'
import * as VueScrollTo  from 'vue-scrollto'

  export default {
    name: 'navigation',
    created: function () {

    },
    methods: {
      gotoscroll: function (e) {
        if(e==='top'){
          VueScrollTo.scrollTo('#top', 1000,{easing: 'ease-in-out', offset: -100, cancelable: true})
        }else if(e==='solucoes'){
          VueScrollTo.scrollTo('#solucoes', 1000,{offset: -90, cancelable: true})
        }else if(e==='quem_somos'){
          VueScrollTo.scrollTo('#quem_somos', 1000,{offset: -60, cancelable: true})
        }else if(e==='parceiros'){
          VueScrollTo.scrollTo('#parceiros', 1000,{offset: -60, cancelable: true})
        }else if(e==='contato'){
          VueScrollTo.scrollTo('#contato', 500)
        }

      },
      principalFunctio: function () {
        this.$store.dispatch(CLOSE_BUTTON_ALL).then(() => this.$router.push('/novo'))
      },
      logout: function () {
        this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/entrar'))
      },
      drawerState: function () {
        this.$store.dispatch(NAV_DRAWER)
        ////_x_console.log('drawer from state',this.$store.getters.janelaLateral)
      },
      changeLanguage: function (e) {
        this.$store.dispatch(LANGUAGE,e)
      },
      entrarLogin: function (e) {
        this.$store.dispatch(ENTRARLOGIN,e)
      },
      entrarLoginWindow: function () {
          this.$store.dispatch(ENTRAR_WINDOW,true)
      }
    },
    computed: {
      ...mapGetters(['degreeKind', 'messageShow', 'getProfile', 'isAuthenticated', 'isProfileLoaded', 'janelaLateral','getLanguage', 'getLoginWindow']),
      ...mapState({
        language: state => state.navigation.language,
        loginWindows: state => state.navigation.loginWindow,
        messagesTotal: state => state.messages.userMessagesTotal,
        messageShow: state => state.messages.messageShow,
        authLoading: state => state.auth.status === 'loading',
        name: state => `${state.user.profile.title} ${state.user.profile.name}`,
      }),
    },
    data () {
        return {
        }
      }
  }
</script>



// WEBPACK FOOTER //
// src/components/navigation/index.vue